import axios from "axios";
import Swal from "sweetalert2";
import * as yup from 'yup';
import { useFormik } from "formik";
import { useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material"

const validationSchema = yup.object({
    firstName: yup.string("Enter the first name").required("First Name is required"),
    lastName: yup.string("Enter the last name").required("Last Name is required"),
    email: yup
      .string('Enter the email')
      .email('Enter a valid email')
      .required('Email is required'),
    raterGroup: yup.object().required("Rater Group is required!"),
})

export const EditRater = ({rater, raterGroups, show, setShow, getRaters, ...rest}) => {

    const handleClose = () => setShow(false);
    console.log("rater", rater)

    useEffect(() => {
        formik.setFieldValue("id", rater.id)
        formik.setFieldValue("firstName", rater.firstName)
        formik.setFieldValue("lastName", rater.lastName)
        formik.setFieldValue("email", rater.email)
        formik.setFieldValue('raterGroup', rater.raterGroup);
    }, [rater])

    const initialValues = {
        id: rater.id,
        firstName: rater.firstName,
        lastName: rater.lastName,
        email: rater.email,
        raterGroup: rater.raterGroup
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values) =>{
        axios.put(`api/assessment/updateSubjectRater`, values).then(res => {
            setShow(false)
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                    getRaters()
                })
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            setShow(false)
            Swal.fire(error.response.data.message, '', 'error')
        }); 
    }

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose();
    }

    const handleGroupChange = (e, value) => {
        if(value && value.id){
            formik.setFieldValue('raterGroup', value);            
        }
        else{
            formik.setFieldValue('raterGroup', null);
        }
    }

    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>Edit Rater</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-name">First Name</label>
                                    <div className="input-group input-group-merge">
                                        <span className="input-group-text"><i className="bx bx-user"></i></span>
                                        <input type="text" name="firstName" className="form-control" placeholder="First Name"
                                        onChange={formik.handleChange} 
                                        onBlur={formik.handleBlur}
                                        value={formik.values.firstName}/>
                                    </div>
                                    {formik.touched.firstName && formik.errors.firstName && (<div className="text-danger">{formik.errors.firstName}</div>)}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-name">Last Name</label>
                                    <div className="input-group input-group-merge">
                                        <span className="input-group-text"><i className="bx bx-user"></i></span>
                                        <input type="text" name="lastName" className="form-control" placeholder="Last Name" 
                                        onChange={formik.handleChange} 
                                        onBlur={formik.handleBlur}
                                        value={formik.values.lastName}/>
                                    </div>
                                    {formik.touched.lastName && formik.errors.lastName && (<div className="text-danger">{formik.errors.lastName}</div>)}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-email">Email</label>
                                    <div className="input-group input-group-merge">
                                        <span className="input-group-text"><i className="bx bx-envelope"></i></span>
                                        <input type="email" name="email" id="basic-icon-default-email" className="form-control" placeholder="Rajiv.doe@example.com" aria-label="Rajiv.doe@example.com" aria-describedby="basic-icon-default-email2" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} />
                                    </div>
                                    {formik.touched.email && formik.errors.email && (<div className="text-danger">{formik.errors.email}</div>)}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-phone">Rater Group</label>   
                                    <Autocomplete
                                        id="raterGroupId"
                                        sx={{ width: 'auto' }}
                                        size='small'
                                        options={raterGroups}
                                        getOptionLabel={(option) => option.name}
                                        onChange={handleGroupChange}
                                        value={formik.values.raterGroup}
                                        renderInput={(params) => <TextField {...params} label={"Rater Group"} />}
                                    />
                                    {formik.touched.raterGroup && formik.errors.raterGroup && (<div className="text-danger">{formik.errors.raterGroup}</div>)}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">Update</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}